"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTimeline = fetchTimeline;
exports.fetchFilteredNotifications = fetchFilteredNotifications;
exports.fetchPaginatedFilteredNotifications = fetchPaginatedFilteredNotifications;
exports.setLastAnnouncementTS = setLastAnnouncementTS;
exports.onAnnouncementTabMount = onAnnouncementTabMount;
exports.onAnnouncementTabUnmount = onAnnouncementTabUnmount;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));

var types = _interopRequireWildcard(require("./actionTypes"));

var _TimelineService = _interopRequireDefault(require("../../service/TimelineService"));

var _SearchService = _interopRequireDefault(require("../../service/SearchService"));

var _store = _interopRequireDefault(require("../store"));

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

var _SettingsService = _interopRequireDefault(require("../../service/SettingsService"));

function fetchTimeline() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var ts;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ts = new _TimelineService.default();
                _context.next = 3;
                return ts.fetchTimeline(_store.default, params);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/* returns the set of data based on the filters selected on notificatins pane */


function fetchFilteredNotifications(requestBody, pageOffset) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var filteredNotificationsData, notificationsById;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _SearchService.default.fetchNotifications(requestBody, pageOffset);

              case 3:
                filteredNotificationsData = _context2.sent;
                //transform the array into an object with id as the key
                notificationsById = (0, _keyBy2.default)(filteredNotificationsData.notifications, function (notification) {
                  return notification.id;
                }); // update the store with filtered notification

                dispatch({
                  type: types.FILTERED_NOTIFICATIONS_FETCHED,
                  payload: {
                    notificationsById: notificationsById,
                    offset: filteredNotificationsData.offset,
                    searchQuery: requestBody
                  }
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
/* returns the set of data based on the pageoffset received on the scroll of filtered notifications */


function fetchPaginatedFilteredNotifications(requestBody, pageOffset) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch) {
        var filteredNotificationsData, notificationsById;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _SearchService.default.fetchNotifications(requestBody, pageOffset);

              case 3:
                filteredNotificationsData = _context3.sent;
                //transform the array into an object with id as the key
                notificationsById = (0, _keyBy2.default)(filteredNotificationsData.notifications, function (notification) {
                  return notification.id;
                });
                dispatch({
                  type: types.PAGINATED_FILTEREDNOTIFICATION_FETCHED,
                  payload: {
                    notificationsById: notificationsById,
                    offset: filteredNotificationsData.offset
                  }
                });
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                console.log(_context3.t0);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 8]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

function setLastAnnouncementTS(newTs) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: types.SET_LAST_ANNOUNCEMENT_TS,
                  payload: {
                    'lastSeenTimestamp': newTs
                  }
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

function onAnnouncementTabMount() {
  return _onAnnouncementTabMount.apply(this, arguments);
}

function _onAnnouncementTabMount() {
  _onAnnouncementTabMount = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee5() {
    var setLastTS,
        lastSeenTimestamp,
        userSettings,
        _args5 = arguments;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            setLastTS = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : true;
            lastSeenTimestamp = _PulseUtil.default.getTimeInSeconds();
            _context5.next = 4;
            return (0, _SettingsService.default)().getUserSettings();

          case 4:
            userSettings = _context5.sent;
            _context5.t0 = userSettings && userSettings.lastSeenAnnouncementsTimestamp;

            if (!_context5.t0) {
              _context5.next = 9;
              break;
            }

            _context5.next = 9;
            return _store.default.dispatch({
              type: types.SET_LAST_SEEN_ANNOUNCEMENT_TS,
              payload: userSettings.lastSeenAnnouncementsTimestamp
            });

          case 9:
            _context5.t1 = setLastTS;

            if (!_context5.t1) {
              _context5.next = 13;
              break;
            }

            _context5.next = 13;
            return _store.default.dispatch({
              type: types.SET_LAST_ANNOUNCEMENT_TS,
              payload: {
                lastSeenTimestamp: lastSeenTimestamp
              }
            });

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _onAnnouncementTabMount.apply(this, arguments);
}

function onAnnouncementTabUnmount() {
  return _onAnnouncementTabUnmount.apply(this, arguments);
}

function _onAnnouncementTabUnmount() {
  _onAnnouncementTabUnmount = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee6() {
    var lastSeenTimestamp;
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            lastSeenTimestamp = _PulseUtil.default.getTimeInSeconds();
            _context6.next = 3;
            return (0, _SettingsService.default)().updateUserSettings({
              lastSeenAnnouncementsTimestamp: lastSeenTimestamp
            });

          case 3:
            _context6.next = 5;
            return _store.default.dispatch({
              type: types.SET_LAST_SEEN_ANNOUNCEMENT_TS,
              payload: lastSeenTimestamp
            });

          case 5:
            _context6.next = 7;
            return _store.default.dispatch({
              type: types.SET_LAST_ANNOUNCEMENT_TS,
              payload: {
                lastSeenTimestamp: lastSeenTimestamp
              }
            });

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _onAnnouncementTabUnmount.apply(this, arguments);
}